import { clsx, type ClassValue } from "clsx";
export function cn(...v: ClassValue[]) {
  return clsx(v);
}
